import React from 'react';
import { ChevronDown } from '@gravity-ui/icons';
import { Button, Icon, Text } from '@gravity-ui/uikit';
import isString from 'lodash/isString';
import { block } from '../../utils';
import './AccordeonCard.css';
const b = block('accordeon-card');
export const AccordeonCard = ({ className, name, header, description, open: propsOpen, onToggle, headerActionsTemplate, ignoreHeaderToggle, titleSize = 'm', alwaysOpen, children, classNameBody, }) => {
    const accordeonRef = React.useRef(null);
    const bodyRef = React.useRef(null);
    const [open, setOpen] = React.useState(alwaysOpen || propsOpen || false);
    const handleToggle = React.useCallback(() => {
        setOpen(!open);
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(!open);
    }, [open, setOpen, onToggle]);
    const preventEvent = React.useCallback((e) => e.stopPropagation(), []);
    const emptyBody = bodyRef.current && !bodyRef.current.childElementCount;
    React.useEffect(() => {
        if (!alwaysOpen && propsOpen !== undefined && propsOpen !== open) {
            setOpen(propsOpen);
        }
    }, [propsOpen]);
    React.useEffect(() => {
        if (bodyRef.current &&
            !bodyRef.current.childElementCount &&
            accordeonRef.current &&
            !accordeonRef.current.className.includes('df-accordeon-card_empty')) {
            accordeonRef.current.classList.add('df-accordeon-card_empty');
        }
    });
    const currentHeaderVariant = React.useMemo(() => {
        if (!isString(header)) {
            return 'body-1';
        }
        if (titleSize === 'm') {
            return 'subheader-2';
        }
        return 'subheader-1';
    }, [titleSize]);
    return (React.createElement("div", { ref: accordeonRef, className: b({ empty: Boolean(emptyBody) }, className) },
        React.createElement("div", { className: b('header', {
                open: open && !emptyBody,
                'without-action': ignoreHeaderToggle || alwaysOpen,
            }), onClick: !ignoreHeaderToggle && !alwaysOpen ? handleToggle : undefined },
            React.createElement("div", { className: b('header-content') },
                React.createElement(Text, { variant: currentHeaderVariant }, header),
                description ? (React.createElement("span", { className: b('header-content-description'), dangerouslySetInnerHTML: { __html: description } })) : null),
            !emptyBody && !alwaysOpen ? (React.createElement("div", { className: b('header-toggle-btn'), onClick: preventEvent },
                headerActionsTemplate ? (React.createElement("div", { className: b('interal-actions') }, headerActionsTemplate)) : null,
                React.createElement(Button, { view: "flat", onClick: handleToggle, qa: `${name}-accordeon-toggler` },
                    React.createElement(Icon, { className: b('toggle-icon', { open }), data: ChevronDown, size: 16 })))) : null),
        React.createElement("div", { ref: bodyRef, className: b('body', { open: open && !emptyBody }, classNameBody) }, children)));
};
